"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6348],{

/***/ 6834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ nullable; },
/* harmony export */   "FX": function() { return /* binding */ getAddStringContext; },
/* harmony export */   "n1": function() { return /* binding */ addCustomAttributes; },
/* harmony export */   "uR": function() { return /* binding */ numeric; }
/* harmony export */ });
/* harmony import */ var _util_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4155);
/* harmony import */ var _config_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3807);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



var hasOwnProp = Object.prototype.hasOwnProperty;
var MAX_ATTRIBUTES = 64;
function nullable(val, fn, comma) {
  return val || val === 0 || val === '' ? fn(val) + (comma ? ',' : '') : '!';
}
function numeric(n, noDefault) {
  if (noDefault) {
    return Math.floor(n).toString(36);
  }
  return n === undefined || n === 0 ? '' : Math.floor(n).toString(36);
}
function getAddStringContext(agentIdentifier) {
  let stringTableIdx = 0;
  const stringTable = Object.prototype.hasOwnProperty.call(Object, 'create') ? Object.create(null) : {};
  const obfuscator = (0,_config_runtime__WEBPACK_IMPORTED_MODULE_1__/* .getRuntime */ .O)(agentIdentifier).obfuscator;
  return addString;
  function addString(str) {
    if (typeof str === 'undefined' || str === '') return '';
    str = obfuscator.obfuscateString(String(str));
    if (hasOwnProp.call(stringTable, str)) {
      return numeric(stringTable[str], true);
    } else {
      stringTable[str] = stringTableIdx++;
      return quoteString(str);
    }
  }
}
function addCustomAttributes(attrs, addString) {
  var attrParts = [];
  Object.entries(attrs || {}).forEach(([key, val]) => {
    if (attrParts.length >= MAX_ATTRIBUTES) return;
    var type = 5;
    var serializedValue;
    // add key to string table first
    key = addString(key);
    switch (typeof val) {
      case 'object':
        if (val) {
          // serialize objects to strings
          serializedValue = addString((0,_util_stringify__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .P)(val));
        } else {
          // null attribute type
          type = 9;
        }
        break;
      case 'number':
        type = 6;
        // make sure numbers contain a `.` so they are parsed as doubles
        serializedValue = val % 1 ? val : val + '.';
        break;
      case 'boolean':
        type = val ? 7 : 8;
        break;
      case 'undefined':
        // we treat undefined as a null attribute (since dirac does not have a concept of undefined)
        type = 9;
        break;
      default:
        serializedValue = addString(val);
    }
    attrParts.push([type, key + (serializedValue ? ',' + serializedValue : '')]);
  });
  return attrParts;
}
var escapable = /([,\\;])/g;
function quoteString(str) {
  return "'" + str.replace(escapable, '\\$1');
}

/***/ }),

/***/ 5498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ eventOrigin; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Returns a string representing the origin of an event target. Used by SessionTrace and PageViewTiming features to assign a "better" target to events
 * @param {*} t The target to derive the origin from.
 * @param {*} [target] A known target to compare to. If supplied, and a derived origin could not be reached, this will be referenced.
 * @param {*} [ee] An event emitter instance to use for context retrieval, which only applies to XMLHttpRequests.
 * @returns {string} The derived origin of the event target.
 */
function eventOrigin(t, target, ee) {
  let origin = 'unknown';
  if (t && t instanceof XMLHttpRequest) {
    const params = ee.context(t).params;
    if (!params || !params.status || !params.method || !params.host || !params.pathname) return 'xhrOriginMissing';
    origin = params.status + ' ' + params.method + ': ' + params.host + params.pathname;
  } else if (t && typeof t.tagName === 'string') {
    origin = t.tagName.toLowerCase();
    if (t.id) origin += '#' + t.id;
    if (t.className) {
      for (let i = 0; i < t.classList.length; i++) origin += '.' + t.classList[i];
    }
  }
  if (origin === 'unknown') {
    if (typeof target === 'string') origin = target;else if (target === document) origin = 'document';else if (target === window) origin = 'window';else if (target instanceof FileReader) origin = 'FileReader';
  }
  return origin;
}

/***/ }),

/***/ 2148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ VITAL_NAMES; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const VITAL_NAMES = {
  FIRST_PAINT: 'fp',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_INTERACTION: 'fi',
  LARGEST_CONTENTFUL_PAINT: 'lcp',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  INTERACTION_TO_NEXT_PAINT: 'inp',
  TIME_TO_FIRST_BYTE: 'ttfb'
};

/***/ }),

/***/ 3892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ firstContentfulPaint; }
/* harmony export */ });
/* harmony import */ var web_vitals_attribution__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8629);
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2656);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

// eslint-disable-next-line camelcase



const firstContentfulPaint = new _vital_metric__WEBPACK_IMPORTED_MODULE_3__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_2__/* .VITAL_NAMES.FIRST_CONTENTFUL_PAINT */ .S.FIRST_CONTENTFUL_PAINT);

/* First Contentful Paint - As of WV v3, it still imperfectly tries to detect document vis state asap and isn't supposed to report if page starts hidden. */
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .isBrowserScope */ .il) {
  // eslint-disable-next-line camelcase
  if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .iOSBelow16 */ .ux) {
    try {
      if (!_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .initiallyHidden */ .iS) {
        // see ios-version.js for detail on this following bug case; tldr: buffered flag doesn't work but getEntriesByType does
        const paintEntries = performance.getEntriesByType('paint');
        paintEntries.forEach(entry => {
          if (entry.name === 'first-contentful-paint') {
            firstContentfulPaint.update({
              value: Math.floor(entry.startTime)
            });
          }
        });
      }
    } catch (e) {
      // ignore
    }
  } else {
    (0,web_vitals_attribution__WEBPACK_IMPORTED_MODULE_0__/* .onFCP */ .a4)(({
      value,
      attribution
    }) => {
      if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .initiallyHidden */ .iS || firstContentfulPaint.isValid) return;
      const attrs = {
        timeToFirstByte: attribution.timeToFirstByte,
        firstByteToFCP: attribution.firstByteToFCP,
        loadState: attribution.loadState
      };
      firstContentfulPaint.update({
        value,
        attrs
      });
    });
  }
}

/***/ }),

/***/ 3600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ firstPaint; }
/* harmony export */ });
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2656);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



const firstPaint = new _vital_metric__WEBPACK_IMPORTED_MODULE_2__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_1__/* .VITAL_NAMES.FIRST_PAINT */ .S.FIRST_PAINT);
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserScope */ .il) {
  const handleEntries = entries => {
    entries.forEach(entry => {
      if (entry.name === 'first-paint' && !firstPaint.isValid) {
        observer.disconnect();

        /* Initial hidden state and pre-rendering not yet considered for first paint. See web-vitals onFCP for example. */
        firstPaint.update({
          value: entry.startTime
        });
      }
    });
  };
  let observer;
  try {
    if (PerformanceObserver.supportedEntryTypes.includes('paint') && !_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .initiallyHidden */ .iS) {
      observer = new PerformanceObserver(list => {
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(() => {
          handleEntries(list.getEntries());
        });
      });
      observer.observe({
        type: 'paint',
        buffered: true
      });
    }
  } catch (e) {
    // Do nothing.
  }
}

/***/ }),

/***/ 755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ timeToFirstByte; }
/* harmony export */ });
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2656);
/* harmony import */ var web_vitals_attribution__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8629);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




const timeToFirstByte = new _vital_metric__WEBPACK_IMPORTED_MODULE_3__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_1__/* .VITAL_NAMES.TIME_TO_FIRST_BYTE */ .S.TIME_TO_FIRST_BYTE);

/**
 * onTTFB is not supported in the following scenarios:
 * - in a non-browser scope
 * - in browsers that do not support PerformanceNavigationTiming API
 * - in an iOS browser
 * - cross-origin iframes specifically in firefox and safari
 */
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserScope */ .il && typeof PerformanceNavigationTiming !== 'undefined' && !_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isiOS */ .Tt && window === window.parent) {
  (0,web_vitals_attribution__WEBPACK_IMPORTED_MODULE_2__/* .onTTFB */ .mr)(({
    value,
    attribution
  }) => {
    if (timeToFirstByte.isValid) return;
    timeToFirstByte.update({
      value,
      attrs: {
        navigationEntry: attribution.navigationEntry
      }
    });
  });
} else {
  if (!timeToFirstByte.isValid) {
    const entry = {};
    // convert real timestamps to relative timestamps to match web-vitals behavior
    for (let key in _constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .globalScope */ ._A?.performance?.timing || {}) entry[key] = Math.max(_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .globalScope */ ._A?.performance?.timing[key] - _constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .originTime */ .sK, 0);

    // ttfb is equiv to document's responseStart property in timing API --> https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming/responseStart
    timeToFirstByte.update({
      value: entry.responseStart,
      attrs: {
        navigationEntry: entry
      }
    });
  }
}

/***/ }),

/***/ 2656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ VitalMetric; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
class VitalMetric {
  #subscribers = new Set();
  history = [];
  constructor(name, roundingMethod) {
    this.name = name;
    this.attrs = {};
    this.roundingMethod = typeof roundingMethod === 'function' ? roundingMethod : Math.floor;
  }
  update({
    value,
    attrs = {}
  }) {
    if (value === undefined || value === null || value < 0) return;
    const state = {
      value: this.roundingMethod(value),
      name: this.name,
      attrs
    };
    this.history.push(state);
    this.#subscribers.forEach(cb => {
      try {
        cb(state);
      } catch (e) {
        // ignore errors
      }
    });
  }
  get current() {
    return this.history[this.history.length - 1] || {
      value: undefined,
      name: this.name,
      attrs: {}
    };
  }
  get isValid() {
    return this.current.value >= 0;
  }
  subscribe(callback, buffered = true) {
    if (typeof callback !== 'function') return;
    this.#subscribers.add(callback);
    // emit full history on subscription ("buffered" behavior)
    if (this.isValid && !!buffered) this.history.forEach(state => {
      callback(state);
    });
    return () => {
      this.#subscribers.delete(callback);
    };
  }
}

/***/ }),

/***/ 4471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/serialize/bel-serializer.js
var bel_serializer = __webpack_require__(6834);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/page_view_timing/constants.js
var constants = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/web-vitals/dist/web-vitals.attribution.js
var web_vitals_attribution = __webpack_require__(8629);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/constants.js
var vitals_constants = __webpack_require__(2148);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/vital-metric.js
var vital_metric = __webpack_require__(2656);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/cumulative-layout-shift.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




const cumulativeLayoutShift = new vital_metric/* VitalMetric */.U(vitals_constants/* VITAL_NAMES.CUMULATIVE_LAYOUT_SHIFT */.S.CUMULATIVE_LAYOUT_SHIFT, x => x);
if (runtime/* isBrowserScope */.il) {
  (0,web_vitals_attribution/* onCLS */.mw)(({
    value,
    attribution,
    id
  }) => {
    const attrs = {
      metricId: id,
      largestShiftTarget: attribution.largestShiftTarget,
      largestShiftTime: attribution.largestShiftTime,
      largestShiftValue: attribution.largestShiftValue,
      loadState: attribution.loadState
    };
    cumulativeLayoutShift.update({
      value,
      attrs
    });
  }, {
    reportAllChanges: true
  });
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-contentful-paint.js
var first_contentful_paint = __webpack_require__(3892);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-paint.js
var first_paint = __webpack_require__(3600);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/interaction-to-next-paint.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




const interactionToNextPaint = new vital_metric/* VitalMetric */.U(vitals_constants/* VITAL_NAMES.INTERACTION_TO_NEXT_PAINT */.S.INTERACTION_TO_NEXT_PAINT);
if (runtime/* isBrowserScope */.il) {
  /* Interaction-to-Next-Paint */
  (0,web_vitals_attribution/* onINP */.Yn)(({
    value,
    attribution,
    id
  }) => {
    const attrs = {
      metricId: id,
      eventTarget: attribution.interactionTarget,
      // event* attrs deprecated in v4, kept for NR backwards compatibility
      eventTime: attribution.interactionTime,
      // event* attrs deprecated in v4, kept for NR backwards compatibility
      interactionTarget: attribution.interactionTarget,
      interactionTime: attribution.interactionTime,
      interactionType: attribution.interactionType,
      inputDelay: attribution.inputDelay,
      nextPaintTime: attribution.nextPaintTime,
      processingDuration: attribution.processingDuration,
      presentationDelay: attribution.presentationDelay,
      loadState: attribution.loadState
    };
    interactionToNextPaint.update({
      value,
      attrs
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/largest-contentful-paint.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */





const largestContentfulPaint = new vital_metric/* VitalMetric */.U(vitals_constants/* VITAL_NAMES.LARGEST_CONTENTFUL_PAINT */.S.LARGEST_CONTENTFUL_PAINT);
if (runtime/* isBrowserScope */.il) {
  (0,web_vitals_attribution/* onLCP */.NO)(({
    value,
    attribution
  }) => {
    /* Largest Contentful Paint - As of WV v3, it still imperfectly tries to detect document vis state asap and isn't supposed to report if page starts hidden. */
    if (runtime/* initiallyHidden */.iS || largestContentfulPaint.isValid) return;
    let attrs;
    const lcpEntry = attribution.lcpEntry;
    if (lcpEntry) {
      attrs = {
        size: lcpEntry.size,
        eid: lcpEntry.id,
        element: attribution.element,
        timeToFirstByte: attribution.timeToFirstByte,
        resourceLoadDelay: attribution.resourceLoadDelay,
        resourceLoadDuration: attribution.resourceLoadDuration,
        resourceLoadTime: attribution.resourceLoadDuration,
        // kept for NR backwards compatibility, deprecated in v3->v4
        elementRenderDelay: attribution.elementRenderDelay
      };
      if (attribution.url) attrs.elUrl = (0,clean_url/* cleanURL */.f)(attribution.url);
      if (lcpEntry.element?.tagName) attrs.elTag = lcpEntry.element.tagName;
    }
    largestContentfulPaint.update({
      value,
      attrs
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/time-to-first-byte.js
var time_to_first_byte = __webpack_require__(755);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/page-visibility.js
var page_visibility = __webpack_require__(7973);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/event-origin.js
var event_origin = __webpack_require__(5498);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/page_view_timing/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

















class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t;
  #handleVitalMetric = ({
    name,
    value,
    attrs
  }) => {
    this.addTiming(name, value, attrs);
  };
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t);
    this.curSessEndRecorded = false;
    this.firstIxnRecorded = false;
    (0,register_handler/* registerHandler */.X)('docHidden', msTimestamp => this.endCurrentSession(msTimestamp), this.featureName, this.ee);
    // Add the time of _window pagehide event_ firing to the next PVT harvest == NRDB windowUnload attr:
    (0,register_handler/* registerHandler */.X)('winPagehide', msTimestamp => this.addTiming('unload', msTimestamp, null), this.featureName, this.ee);
    this.waitForFlags([]).then(() => {
      first_paint/* firstPaint.subscribe */.U.subscribe(this.#handleVitalMetric);
      first_contentful_paint/* firstContentfulPaint.subscribe */.y.subscribe(this.#handleVitalMetric);
      largestContentfulPaint.subscribe(this.#handleVitalMetric);
      interactionToNextPaint.subscribe(this.#handleVitalMetric);
      time_to_first_byte/* timeToFirstByte.subscribe */.P.subscribe(({
        attrs
      }) => {
        this.addTiming('load', Math.round(attrs.navigationEntry.loadEventEnd));
      });
      (0,page_visibility/* subscribeToVisibilityChange */.N)(() => {
        /* Downstream, the event consumer interprets all timing node value as ms-unit and converts it to seconds via division by 1000. CLS is unitless so this normally is a problem.
          bel.6 schema also doesn't support decimal values, of which cls within [0,1). However, the two nicely cancels out, and we can multiply cls by 1000 to both negate the division
          and send an integer > 1. We effectively lose some precision down to 3 decimal places for this workaround. E.g. (real) 0.749132... -> 749.132...-> 749 -> 0.749 (final) */
        const {
          name,
          value,
          attrs
        } = cumulativeLayoutShift.current;
        if (value === undefined) return;
        this.addTiming(name, value * 1000, attrs);
      }, true, true); // CLS node should only reports on vis change rather than on every change

      this.drain();
    });
  }

  /**
   * Add the time of _document visibilitychange to hidden_ to the next PVT harvest == NRDB pageHide attr.
   * @param {number} timestamp
   */
  endCurrentSession(timestamp) {
    if (!this.curSessEndRecorded) {
      // TO DO: stage 2 - we don't want to capture this timing twice on page navigating away, but it should run again if we return to page and away *again*
      this.addTiming('pageHide', timestamp, null);
      this.curSessEndRecorded = true;
    }
  }
  addTiming(name, value, attrs) {
    attrs = attrs || {};
    addConnectionAttributes(attrs); // network conditions may differ from the actual for VitalMetrics when they were captured

    // If cls was set to another value by `onCLS`, then it's supported and is attached onto any timing but is omitted until such time.
    /*
    *cli Apr'23 - Convert attach-to-all -> attach-if-not-null. See NEWRELIC-6143.
    Issue: Because NR 'pageHide' was only sent once with what is considered the "final" CLS value, in the case that 'pageHide' fires before 'load' happens, we incorrectly a final CLS of 0 for that page.
    Mitigation: We've set initial CLS to null so that it's omitted from timings like 'pageHide' in that edge case. It should only be included if onCLS callback was executed at least once.
    Future: onCLS value changes should be reported directly & CLS separated into its own timing node so it's not beholden to 'pageHide' firing. It'd also be possible to report the real final CLS.
    *cli Mar'24 update: CLS now emitted as its own timing node in addition to as-property under other nodes. The 'cls' property is unnecessary for cls nodes.
    */
    if (name !== vitals_constants/* VITAL_NAMES.CUMULATIVE_LAYOUT_SHIFT */.S.CUMULATIVE_LAYOUT_SHIFT && cumulativeLayoutShift.current.value >= 0) {
      attrs.cls = cumulativeLayoutShift.current.value;
    }
    const timing = {
      name,
      value,
      attrs
    };
    this.events.add(timing);
    (0,handle/* handle */.p)('pvtAdded', [name, value, attrs], undefined, features/* FEATURE_NAMES.sessionTrace */.DT.sessionTrace, this.ee);
    this.checkForFirstInteraction();

    // makes testing easier
    return timing;
  }

  /**
   * Checks the performance API to see if the agent can set a first interaction event value
   * @returns {void}
   */
  checkForFirstInteraction() {
    // preserve the original behavior where FID is not reported if the page is hidden before the first interaction
    if (this.firstIxnRecorded || runtime/* initiallyHidden */.iS || !performance) return;
    const firstInput = performance.getEntriesByType('first-input')[0];
    if (!firstInput) return;
    this.firstIxnRecorded = true;
    this.addTiming('fi', firstInput.startTime, {
      type: firstInput.name,
      eventTarget: (0,event_origin/* eventOrigin */._)(firstInput.target),
      loadState: document.readyState
    });
  }
  appendGlobalCustomAttributes(timing) {
    var timingAttributes = timing.attrs || {};
    var reservedAttributes = ['size', 'eid', 'cls', 'type', 'fid', 'elTag', 'elUrl', 'net-type', 'net-etype', 'net-rtt', 'net-dlink'];
    Object.entries(this.agentRef.info.jsAttributes || {}).forEach(([key, val]) => {
      if (reservedAttributes.indexOf(key) < 0) {
        timingAttributes[key] = val;
      }
    });
  }
  preHarvestChecks() {
    this.checkForFirstInteraction();
    return super.preHarvestChecks();
  }

  // serialize array of timing data
  serializer(eventBuffer) {
    var addString = (0,bel_serializer/* getAddStringContext */.FX)(this.agentIdentifier);
    var payload = 'bel.6;';
    for (var i = 0; i < eventBuffer.length; i++) {
      var timing = eventBuffer[i];
      payload += 'e,';
      payload += addString(timing.name) + ',';
      payload += (0,bel_serializer/* nullable */.AG)(timing.value, bel_serializer/* numeric */.uR, false) + ',';
      this.appendGlobalCustomAttributes(timing);
      var attrParts = (0,bel_serializer/* addCustomAttributes */.n1)(timing.attrs, addString);
      if (attrParts && attrParts.length > 0) {
        payload += (0,bel_serializer/* numeric */.uR)(attrParts.length) + ';' + attrParts.join(';');
      }
      if (i + 1 < eventBuffer.length) payload += ';';
    }
    return payload;
  }
}
function addConnectionAttributes(obj) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection; // to date, both window & worker shares the same support for connection
  if (!connection) return;
  if (connection.type) obj['net-type'] = connection.type;
  if (connection.effectiveType) obj['net-etype'] = connection.effectiveType;
  if (connection.rtt) obj['net-rtt'] = connection.rtt;
  if (connection.downlink) obj['net-dlink'] = connection.downlink;
}

/***/ }),

/***/ 8629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NO": function() { return /* binding */ ot; },
/* harmony export */   "Yn": function() { return /* binding */ rt; },
/* harmony export */   "a4": function() { return /* binding */ w; },
/* harmony export */   "mr": function() { return /* binding */ ft; },
/* harmony export */   "mw": function() { return /* binding */ D; }
/* harmony export */ });
/* unused harmony exports CLSThresholds, FCPThresholds, FIDThresholds, INPThresholds, LCPThresholds, TTFBThresholds, onFID */
var t,e,n=function(){var t=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},r=function(t){if("loading"===document.readyState)return"loading";var e=n();if(e){if(t<e.domInteractive)return"loading";if(0===e.domContentLoadedEventStart||t<e.domContentLoadedEventStart)return"dom-interactive";if(0===e.domComplete||t<e.domComplete)return"dom-content-loaded"}return"complete"},i=function(t){var e=t.nodeName;return 1===t.nodeType?e.toLowerCase():e.toUpperCase().replace(/^#/,"")},a=function(t,e){var n="";try{for(;t&&9!==t.nodeType;){var r=t,a=r.id?"#"+r.id:i(r)+(r.classList&&r.classList.value&&r.classList.value.trim()&&r.classList.value.trim().length?"."+r.classList.value.trim().replace(/\s+/g,"."):"");if(n.length+a.length>(e||100)-1)return n||a;if(n=n?a+">"+n:a,r.id)break;t=r.parentNode}}catch(t){}return n},o=-1,c=function(){return o},u=function(t){addEventListener("pageshow",(function(e){e.persisted&&(o=e.timeStamp,t(e))}),!0)},s=function(){var t=n();return t&&t.activationStart||0},f=function(t,e){var r=n(),i="navigate";c()>=0?i="back-forward-cache":r&&(document.prerendering||s()>0?i="prerender":document.wasDiscarded?i="restore":r.type&&(i=r.type.replace(/_/g,"-")));return{name:t,value:void 0===e?-1:e,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},d=function(t,e,n){try{if(PerformanceObserver.supportedEntryTypes.includes(t)){var r=new PerformanceObserver((function(t){Promise.resolve().then((function(){e(t.getEntries())}))}));return r.observe(Object.assign({type:t,buffered:!0},n||{})),r}}catch(t){}},l=function(t,e,n,r){var i,a;return function(o){e.value>=0&&(o||r)&&((a=e.value-(i||0))||void 0===i)&&(i=e.value,e.delta=a,e.rating=function(t,e){return t>e[1]?"poor":t>e[0]?"needs-improvement":"good"}(e.value,n),t(e))}},m=function(t){requestAnimationFrame((function(){return requestAnimationFrame((function(){return t()}))}))},p=function(t){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&t()}))},v=function(t){var e=!1;return function(){e||(t(),e=!0)}},g=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},T=function(t){"hidden"===document.visibilityState&&g>-1&&(g="visibilitychange"===t.type?t.timeStamp:0,E())},y=function(){addEventListener("visibilitychange",T,!0),addEventListener("prerenderingchange",T,!0)},E=function(){removeEventListener("visibilitychange",T,!0),removeEventListener("prerenderingchange",T,!0)},S=function(){return g<0&&(g=h(),y(),u((function(){setTimeout((function(){g=h(),y()}),0)}))),{get firstHiddenTime(){return g}}},b=function(t){document.prerendering?addEventListener("prerenderingchange",(function(){return t()}),!0):t()},L=[1800,3e3],C=function(t,e){e=e||{},b((function(){var n,r=S(),i=f("FCP"),a=d("paint",(function(t){t.forEach((function(t){"first-contentful-paint"===t.name&&(a.disconnect(),t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-s(),0),i.entries.push(t),n(!0)))}))}));a&&(n=l(t,i,L,e.reportAllChanges),u((function(r){i=f("FCP"),n=l(t,i,L,e.reportAllChanges),m((function(){i.value=performance.now()-r.timeStamp,n(!0)}))})))}))},M=[.1,.25],D=function(t,e){!function(t,e){e=e||{},C(v((function(){var n,r=f("CLS",0),i=0,a=[],o=function(t){t.forEach((function(t){if(!t.hadRecentInput){var e=a[0],n=a[a.length-1];i&&t.startTime-n.startTime<1e3&&t.startTime-e.startTime<5e3?(i+=t.value,a.push(t)):(i=t.value,a=[t])}})),i>r.value&&(r.value=i,r.entries=a,n())},c=d("layout-shift",o);c&&(n=l(t,r,M,e.reportAllChanges),p((function(){o(c.takeRecords()),n(!0)})),u((function(){i=0,r=f("CLS",0),n=l(t,r,M,e.reportAllChanges),m((function(){return n()}))})),setTimeout(n,0))})))}((function(e){var n=function(t){var e,n={};if(t.entries.length){var i=t.entries.reduce((function(t,e){return t&&t.value>e.value?t:e}));if(i&&i.sources&&i.sources.length){var o=(e=i.sources).find((function(t){return t.node&&1===t.node.nodeType}))||e[0];o&&(n={largestShiftTarget:a(o.node),largestShiftTime:i.startTime,largestShiftValue:i.value,largestShiftSource:o,largestShiftEntry:i,loadState:r(i.startTime)})}}return Object.assign(t,{attribution:n})}(e);t(n)}),e)},w=function(t,e){C((function(e){var i=function(t){var e={timeToFirstByte:0,firstByteToFCP:t.value,loadState:r(c())};if(t.entries.length){var i=n(),a=t.entries[t.entries.length-1];if(i){var o=i.activationStart||0,u=Math.max(0,i.responseStart-o);e={timeToFirstByte:u,firstByteToFCP:t.value-u,loadState:r(t.entries[0].startTime),navigationEntry:i,fcpEntry:a}}}return Object.assign(t,{attribution:e})}(e);t(i)}),e)},x=0,I=1/0,k=0,A=function(t){t.forEach((function(t){t.interactionId&&(I=Math.min(I,t.interactionId),k=Math.max(k,t.interactionId),x=k?(k-I)/7+1:0)}))},F=function(){return t?x:performance.interactionCount||0},P=function(){"interactionCount"in performance||t||(t=d("event",A,{type:"event",buffered:!0,durationThreshold:0}))},B=[],O=new Map,R=0,j=function(){var t=Math.min(B.length-1,Math.floor((F()-R)/50));return B[t]},q=[],H=function(t){if(q.forEach((function(e){return e(t)})),t.interactionId||"first-input"===t.entryType){var e=B[B.length-1],n=O.get(t.interactionId);if(n||B.length<10||t.duration>e.latency){if(n)t.duration>n.latency?(n.entries=[t],n.latency=t.duration):t.duration===n.latency&&t.startTime===n.entries[0].startTime&&n.entries.push(t);else{var r={id:t.interactionId,latency:t.duration,entries:[t]};O.set(r.id,r),B.push(r)}B.sort((function(t,e){return e.latency-t.latency})),B.length>10&&B.splice(10).forEach((function(t){return O.delete(t.id)}))}}},N=function(t){var e=self.requestIdleCallback||self.setTimeout,n=-1;return t=v(t),"hidden"===document.visibilityState?t():(n=e(t),p(t)),n},W=[200,500],z=function(t,e){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(e=e||{},b((function(){var n;P();var r,i=f("INP"),a=function(t){N((function(){t.forEach(H);var e=j();e&&e.latency!==i.value&&(i.value=e.latency,i.entries=e.entries,r())}))},o=d("event",a,{durationThreshold:null!==(n=e.durationThreshold)&&void 0!==n?n:40});r=l(t,i,W,e.reportAllChanges),o&&(o.observe({type:"first-input",buffered:!0}),p((function(){a(o.takeRecords()),r(!0)})),u((function(){R=F(),B.length=0,O.clear(),i=f("INP"),r=l(t,i,W,e.reportAllChanges)})))})))},U=[],V=[],_=0,G=new WeakMap,J=new Map,K=-1,Q=function(t){U=U.concat(t),X()},X=function(){K<0&&(K=N(Y))},Y=function(){J.size>10&&J.forEach((function(t,e){O.has(e)||J.delete(e)}));var t=B.map((function(t){return G.get(t.entries[0])})),e=V.length-50;V=V.filter((function(n,r){return r>=e||t.includes(n)}));for(var n=new Set,r=0;r<V.length;r++){var i=V[r];nt(i.startTime,i.processingEnd).forEach((function(t){n.add(t)}))}var a=U.length-1-50;U=U.filter((function(t,e){return t.startTime>_&&e>a||n.has(t)})),K=-1};q.push((function(t){t.interactionId&&t.target&&!J.has(t.interactionId)&&J.set(t.interactionId,t.target)}),(function(t){var e,n=t.startTime+t.duration;_=Math.max(_,t.processingEnd);for(var r=V.length-1;r>=0;r--){var i=V[r];if(Math.abs(n-i.renderTime)<=8){(e=i).startTime=Math.min(t.startTime,e.startTime),e.processingStart=Math.min(t.processingStart,e.processingStart),e.processingEnd=Math.max(t.processingEnd,e.processingEnd),e.entries.push(t);break}}e||(e={startTime:t.startTime,processingStart:t.processingStart,processingEnd:t.processingEnd,renderTime:n,entries:[t]},V.push(e)),(t.interactionId||"first-input"===t.entryType)&&G.set(t,e),X()}));var Z,$,tt,et,nt=function(t,e){for(var n,r=[],i=0;n=U[i];i++)if(!(n.startTime+n.duration<t)){if(n.startTime>e)break;r.push(n)}return r},rt=function(t,n){e||(e=d("long-animation-frame",Q)),z((function(e){var n=function(t){var e=t.entries[0],n=G.get(e),i=e.processingStart,o=n.processingEnd,c=n.entries.sort((function(t,e){return t.processingStart-e.processingStart})),u=nt(e.startTime,o),s=t.entries.find((function(t){return t.target})),f=s&&s.target||J.get(e.interactionId),d=[e.startTime+e.duration,o].concat(u.map((function(t){return t.startTime+t.duration}))),l=Math.max.apply(Math,d),m={interactionTarget:a(f),interactionTargetElement:f,interactionType:e.name.startsWith("key")?"keyboard":"pointer",interactionTime:e.startTime,nextPaintTime:l,processedEventEntries:c,longAnimationFrameEntries:u,inputDelay:i-e.startTime,processingDuration:o-i,presentationDelay:Math.max(l-o,0),loadState:r(e.startTime)};return Object.assign(t,{attribution:m})}(e);t(n)}),n)},it=[2500,4e3],at={},ot=function(t,e){!function(t,e){e=e||{},b((function(){var n,r=S(),i=f("LCP"),a=function(t){e.reportAllChanges||(t=t.slice(-1)),t.forEach((function(t){t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-s(),0),i.entries=[t],n())}))},o=d("largest-contentful-paint",a);if(o){n=l(t,i,it,e.reportAllChanges);var c=v((function(){at[i.id]||(a(o.takeRecords()),o.disconnect(),at[i.id]=!0,n(!0))}));["keydown","click"].forEach((function(t){addEventListener(t,(function(){return N(c)}),{once:!0,capture:!0})})),p(c),u((function(r){i=f("LCP"),n=l(t,i,it,e.reportAllChanges),m((function(){i.value=performance.now()-r.timeStamp,at[i.id]=!0,n(!0)}))}))}}))}((function(e){var r=function(t){var e={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadDuration:0,elementRenderDelay:t.value};if(t.entries.length){var r=n();if(r){var i=r.activationStart||0,o=t.entries[t.entries.length-1],c=o.url&&performance.getEntriesByType("resource").filter((function(t){return t.name===o.url}))[0],u=Math.max(0,r.responseStart-i),s=Math.max(u,c?(c.requestStart||c.startTime)-i:0),f=Math.max(s,c?c.responseEnd-i:0),d=Math.max(f,o.startTime-i);e={element:a(o.element),timeToFirstByte:u,resourceLoadDelay:s-u,resourceLoadDuration:f-s,elementRenderDelay:d-f,navigationEntry:r,lcpEntry:o},o.url&&(e.url=o.url),c&&(e.lcpResourceEntry=c)}}return Object.assign(t,{attribution:e})}(e);t(r)}),e)},ct=[800,1800],ut=function t(e){document.prerendering?b((function(){return t(e)})):"complete"!==document.readyState?addEventListener("load",(function(){return t(e)}),!0):setTimeout(e,0)},st=function(t,e){e=e||{};var r=f("TTFB"),i=l(t,r,ct,e.reportAllChanges);ut((function(){var a=n();a&&(r.value=Math.max(a.responseStart-s(),0),r.entries=[a],i(!0),u((function(){r=f("TTFB",0),(i=l(t,r,ct,e.reportAllChanges))(!0)})))}))},ft=function(t,e){st((function(e){var n=function(t){var e={waitingDuration:0,cacheDuration:0,dnsDuration:0,connectionDuration:0,requestDuration:0};if(t.entries.length){var n=t.entries[0],r=n.activationStart||0,i=Math.max((n.workerStart||n.fetchStart)-r,0),a=Math.max(n.domainLookupStart-r,0),o=Math.max(n.connectStart-r,0),c=Math.max(n.connectEnd-r,0);e={waitingDuration:i,cacheDuration:a-i,dnsDuration:o-a,connectionDuration:c-o,requestDuration:t.value-c,navigationEntry:n}}return Object.assign(t,{attribution:e})}(e);t(n)}),e)},dt={passive:!0,capture:!0},lt=new Date,mt=function(t,e){Z||(Z=e,$=t,tt=new Date,gt(removeEventListener),pt())},pt=function(){if($>=0&&$<tt-lt){var t={entryType:"first-input",name:Z.type,target:Z.target,cancelable:Z.cancelable,startTime:Z.timeStamp,processingStart:Z.timeStamp+$};et.forEach((function(e){e(t)})),et=[]}},vt=function(t){if(t.cancelable){var e=(t.timeStamp>1e12?new Date:performance.now())-t.timeStamp;"pointerdown"==t.type?function(t,e){var n=function(){mt(t,e),i()},r=function(){i()},i=function(){removeEventListener("pointerup",n,dt),removeEventListener("pointercancel",r,dt)};addEventListener("pointerup",n,dt),addEventListener("pointercancel",r,dt)}(e,t):mt(e,t)}},gt=function(t){["mousedown","keydown","touchstart","pointerdown"].forEach((function(e){return t(e,vt,dt)}))},ht=(/* unused pure expression or super */ null && ([100,300])),Tt=function(t,e){e=e||{},b((function(){var n,r=S(),i=f("FID"),a=function(t){t.startTime<r.firstHiddenTime&&(i.value=t.processingStart-t.startTime,i.entries.push(t),n(!0))},o=function(t){t.forEach(a)},c=d("first-input",o);n=l(t,i,ht,e.reportAllChanges),c&&(p(v((function(){o(c.takeRecords()),c.disconnect()}))),u((function(){var r;i=f("FID"),n=l(t,i,ht,e.reportAllChanges),et=[],$=-1,Z=null,gt(addEventListener),r=a,et.push(r),pt()})))}))},yt=function(t,e){Tt((function(e){var n=function(t){var e=t.entries[0],n={eventTarget:a(e.target),eventType:e.name,eventTime:e.startTime,eventEntry:e,loadState:r(e.startTime)};return Object.assign(t,{attribution:n})}(e);t(n)}),e)};


/***/ })

}]);